import Phaser from 'phaser';
import Example from './scenes/ExampleScene';
import RoosterBattleScene from './scenes/RoosterBattleScene';
import Boot from './scenes/Boot';
import Preloader from './scenes/Preloader';

import NewEquipPopup from './scenes/NewEquipPopup';
import WebFontLoaderPlugin from 'phaser3-rex-plugins/plugins/webfontloader-plugin.js';
import EaseMovePlugin from 'phaser3-rex-plugins/plugins/easemove-plugin.js';
import { SpinePlugin } from '@esotericsoftware/spine-phaser';
import eruda from 'eruda';
import axios from 'axios';

// Import the functions you need from the SDKs you need
import { initializeApp, getApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: 'AIzaSyCyUz2g1TuunmtR9dCZfCBIVaR1tHiOIck',
	authDomain: 'dog-mutant.firebaseapp.com',
	projectId: 'dog-mutant',
	storageBucket: 'dog-mutant.appspot.com',
	messagingSenderId: '295690567270',
	appId: '1:295690567270:web:efe6494d13213c7a17b7a7',
	measurementId: 'G-YC13HQXJ3J',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

var currentPendingItem = null;

//const addMessage = httpsCallable(functions, 'addMessage');

eruda.init();

//console.log(Telegram.WebApp.initData);
console.log('ahuhuh');
console.log(Telegram.WebApp.initDataUnsafe);

var customToken;

getData = async () => {
	console.log(Telegram.WebApp.initData);

	const response = await axios.post(
		'https://helloworld-t75wjesv6a-uc.a.run.app?data=' + btoa(Telegram.WebApp.initData),
		{
			firstName: 'Fred',
			lastName: 'Flintstone',
			authenData: Telegram.WebApp.initData,
		},
		{
			headers: {
				'authen-data': Telegram.WebApp.initData,
			},
		}
	);
	const token = response.data;

	const auth = getAuth();
	const userCredential = await signInWithCustomToken(auth, token);
	console.log(userCredential);
	return userCredential.user;
};

startBattle = async () => {
	const startBattle = httpsCallable(functions, 'startBattle');
	const result = await startBattle();
	//console.log(result.data);
	return result.data;
};

summonItem = async () => {
	const summonItem = httpsCallable(functions, 'summonItem');
	const result = await summonItem();
	//console.log(result.data);
	return result.data;
};

equipPendingItem = async () => {
	const equipPendingItem = httpsCallable(functions, 'equipPendingItem');
	const result = await equipPendingItem();
	console.log(result.data);
	return result.data;
};

const config = {
	type: Phaser.AUTO,
	width: 720,
	height: 1280,
	scene: [Boot, Preloader, Example, RoosterBattleScene, NewEquipPopup],
	scale: {
		// Fit to window
		mode: Phaser.Scale.FIT,
		// Center vertically and horizontally
		//autoCenter: Phaser.Scale.CENTER_BOTH,
	},
	plugins: {
		scene: [{ key: 'spine.SpinePlugin', plugin: spine.SpinePlugin, mapping: 'spine', sceneKey: 'spine' }],
		global: [
			{
				key: 'rexWebFontLoader',
				plugin: WebFontLoaderPlugin,
				start: true,
			},
			{
				key: 'rexEaseMove',
				plugin: EaseMovePlugin,
				start: true,
			},
			// ...
		],
	},
};

const game = new Phaser.Game(config);
